import MedicalConditions from "./MedicalConditions";

export default MedicalConditions;
